import axios from 'axios';

export const APP_TITTLE = 'The PLMC';
export const BASE_URL = 'https://api.theplmc.net/api/music/v1';
export const FILE_URL = 'https://theplmc.s3.us-east-2.amazonaws.com';
export const plmcApi = axios.create({
  baseURL: BASE_URL,
});
